var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useFocusRing } from '@react-aria/focus';
import { mergeProps } from '@react-aria/utils';
import { useImperativeHandle, useRef } from 'react';
import { useId } from '../hooks';
import CharacterCount from './character-count';
import { textAreaStyle, textAreaWrapperStyle } from './styles';
function TextAreaInternal(_a, ref) {
    var _b = _a.autoGrow, autoGrow = _b === void 0 ? false : _b, counterAriaLabel = _a.counterAriaLabel, _c = _a.error, error = _c === void 0 ? false : _c, _d = _a.inverted, inverted = _d === void 0 ? false : _d, maxLength = _a.maxLength, showCharacterCount = _a.showCharacterCount, _e = _a.size, size = _e === void 0 ? 'medium' : _e, value = _a.value, restProps = __rest(_a, ["autoGrow", "counterAriaLabel", "error", "inverted", "maxLength", "showCharacterCount", "size", "value"]);
    var _f = useFocusRing(), focusProps = _f.focusProps, isFocusVisible = _f.isFocusVisible;
    var characterCounterId = "character-count-".concat(useId());
    var textAreaRef = useRef(null);
    useImperativeHandle(ref, function () { return textAreaRef.current; });
    function handleInput() {
        if (textAreaRef.current != null) {
            textAreaRef.current.style.height = 'auto';
            textAreaRef.current.style.height = "".concat(textAreaRef.current.scrollHeight, "px");
        }
    }
    return (_jsxs("div", __assign({ css: textAreaWrapperStyle({ inverted: inverted, isFocusVisible: isFocusVisible }) }, { children: [_jsx("textarea", __assign({}, (showCharacterCount && {
                'aria-describedby': characterCounterId,
            }), { "aria-invalid": error, css: textAreaStyle({ hasError: !!error, size: size }), maxLength: maxLength, ref: textAreaRef }, mergeProps(focusProps, restProps, __assign({}, (autoGrow && { onInput: handleInput }))), { value: value })), showCharacterCount && maxLength != null && (_jsx(CharacterCount, __assign({ id: characterCounterId, limit: maxLength }, { counterAriaLabel: counterAriaLabel, size: size, value: value })))] })));
}
export default TextAreaInternal;
